// Core packages
import { Component, Inject, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";

// Third party packages
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { TranslateService } from "@ngx-translate/core";
import { MatProgressButtonOptions } from "mat-progress-buttons";
import { ToastrService } from "ngx-toastr";

/**
 * Script start
 */

@Component({
  selector: "app-property-tag-nfc-reassign-dialog",
  templateUrl: "./property-tag-nfc-reassign-dialog.component.html",
  styleUrls: ["./property-tag-nfc-reassign-dialog.component.scss"],
})
export class PropertyTagNfcReassignDialogComponent implements OnInit {
  // BEGIN - ngx-formly
  form: FormGroup = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  options: FormlyFormOptions = {};
  // END - ngx-formly

  confirmBtnOptions: MatProgressButtonOptions = {
    active: false,
    text: this.translateService.instant("common.cta.confirm"),
    spinnerSize: 19,
    raised: true,
    stroked: true,
    flat: false,
    fab: false,
    buttonColor: "warn",
    spinnerColor: "warn",
    fullWidth: false,
    disabled: false,
    mode: "indeterminate",
    buttonIcon: {
      fontSet: "fal",
      fontIcon: "fa-check-circle",
      inline: true,
    },
  };

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PropertyTagNfcReassignDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService,
    private toastrService: ToastrService
  ) {
    dialogRef.disableClose = true;
  }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    this.initForm();
  }

  /**
   * Init form
   *
   * @since 1.0.0
   */
  initForm(): void {
    const tagOptions = (this.data.tags || []).map((tag: any) => {
      return {
        value: tag._id,
        label: tag.name ? `${tag.uid} - ${tag.name}` : tag.uid,
      };
    });

    this.fields = [
      {
        fieldGroupClassName: "row",
        fieldGroup: [
          {
            className: "col-12",
            type: "select",
            key: "newTagNfcId",
            templateOptions: {
              label: this.translateService.instant(
                "propertyTagNfc.dialog.reassign.fieldLabel"
              ),
              placeholder: this.translateService.instant(
                "propertyTagNfc.dialog.reassign.fieldLabel"
              ),
              required: true,
              multiple: false,
              options: tagOptions,
            },
          },
        ],
      },
    ];
  }

  /**
   * Handle form submit
   *
   * @since 1.0.0
   */
  onFormSubmit(model: any): void {
    // Prevent invalid form submit
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsTouched();
      });
      this.toastrService.error(
        this.translateService.instant("common.errors.form_is_invalid")
      );
      return;
    }

    this.dialogRef.close(model.newTagNfcId);
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close(null);
  }
}
